/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostFeatureFlagPathParams = NonNullable<operations['postFeatureFlag']['parameters']['path']>;

export type PostFeatureFlagQueryParams = NonNullable<operations['postFeatureFlag']['parameters']['query']>;

export type PostFeatureFlagRequestBody = OperationRequestBodyContent<operations['postFeatureFlag']>;

export interface Input extends PostFeatureFlagPathParams {
  apiVersion?: string;
  query?: PostFeatureFlagQueryParams;
  body: PostFeatureFlagRequestBody;
}

export async function postFeatureFlag(
  { apiVersion, body, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/flags/{projectKey}', {
    params: { path, query },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
